import AceEditor from "react-ace";
import "ace-builds/src-noconflict/mode-javascript";
import "ace-builds/src-noconflict/mode-html";
import "ace-builds/src-noconflict/mode-css";
import "ace-builds/src-noconflict/theme-monokai";
export const AjaxXMLHttpRequest = () =>{
    function calcHeight(nbLine){
        let calc = 19*nbLine
        return calc+"px"
        }


    return(
    
        <div id="articleContent">







<h2>Exemple d'appel AJAX avec l'API cryptocompare.com</h2>
                    
<div class="printNone">
                        <div id="bitcoin">
                            <div id="cours"></div>
                            <div id="horo"></div>
                        </div>
                    </div>
                    <h3>version simplifiée</h3>
                    
      <pre>
      <code>
      <AceEditor
      fontSize={16}
      showPrintMargin={false}
      showGutter= {true}
    
          mode="javascript"
          theme="monokai"
          value={`function formatMontant(m) {
            var intlN = new Intl.NumberFormat();
            return intlN.format(m);
}

        function getCours() {
            var ajax = new XMLHttpRequest();
            ajax.onload = function () {
                if (this.status == 200) {
                    try {
                        var json = JSON.parse(this.response);
                    } catch (err) {
                        return false;
                    }
                    if (json.EUR) {
                        var eur = formatMontant(json.EUR);
                        var dt = new Date();
                        document.getElementById("cours").innerHTML = eur + " &euro;";
                        document.querySelector("div#horo").innerHTML = "Maj " + dt.toLocaleString();
                    } else {
                        document.getElementById("cours").innerHTML = "Retour incorrect, mauvais contenu dans l appel";
                    }
                }
            }
            ajax.ontimeout = function () {
                document.getElementById("cours").innerHTML = "Le service n a pas répondu à temps";
                setTimeout("getCours()", 5000);
            }
            var url = "https://min-api.cryptocompare.com/data/price?fsym=BTC&tsyms=EUR";
            ajax.open("GET", url, true);
            // pas utiliser dans ce cas car il y a le onetimeout
            ajax.onerror = function () { console.log("erreur dans l appel"); }
            ajax.timeout = 1000;
            ajax.send();
        }

window.onload = function () {
    getCours();
    setInterval("getCours()", 30000);}
`}
          height={calcHeight(40)}
          width="100%"
        />
      </code>
      </pre>
      <h3>Version commentée</h3>


      <pre>
      <code>
      <AceEditor
      fontSize={16}
      showPrintMargin={false}
      showGutter= {true}
    
          mode="javascript"
          theme="monokai"
          value={`/////// fonction pour formater le nombre 
          function formatMontant(m) {
              var intlN = new Intl.NumberFormat();
              return intlN.format(m);
              // Intl.NumberFormat est un constructeur permettant de créer des objets 
              // pour formater des nombre en fonction de la locale
          }
          
          /////// Fonction pour obtenir le cours du Bitcoin
          function getCours() {
              // Appel AJAX vers cryptocompare.com
              var ajax = new XMLHttpRequest();
              console.log("La valeur de la propriété readyState d'Ajax après new (objet Ajax non initialisé => 0) : " + ajax.readyState);
              // Détection de l'avancement de l'appel
              ajax.onreadystatechange = function () {
                  console.log("La valeur de la propriété readyState d'Ajax a changé et vaut (1,2,3,4) : " + ajax.readyState)
                  // 1 = Objet AJAX initialisé avec open()
                  // 2 = En-tête de réponse disponibles
                  // 3 = Données reçues mais accessibles en partie
                  // 4 = Données complètement accessibles dans response
              }
          
              // Onload est la fonction qui se déclenche quand l'appel est terminé
              ajax.onload = function () {
                  console.log("Appel AJAX terminé");
                  console.log("Valeur de la propriété status d'Ajax : " + this.status);
                  // 200 = OK, tout s'est bien passé
                  // 404 = Ressource introuvable
                  // 401 = Accès interdit
                  // 500 = Erreur de traitement sur le serveur
                  console.log("La valeur de la propriété response d'Ajax: " + this.response);
          
          
                  // Response est le contenu (sous forme d'objet JS) de la réponse envoyé par le serveur
                  if (this.status == 200) { // Si tout s'est bien passé
                      try { // essaye
                          var json = JSON.parse(this.response); // Créer une variable contenant l'objet converti en JSON
                      } catch (err) { // si un mauvais contenu est retourné par l'appel
                          console.log("Retour JSON incorrect, mauvais contenu dans l'appel");
                          return false;// sort du if pour aller dans le else du (json.EUR)
                      }
                      // Vérif dans l'objet JSON (2iem securité) : Vérifier que le JSON de retour contient bien la propriété EUR
                      if (json.EUR) {
                          var eur = formatMontant(json.EUR);
                          var dt = new Date();
                          document.getElementById("cours").innerHTML = eur + " &euro;";
                          document.querySelector("div#horo").innerHTML = "Maj " + dt.toLocaleString();// affiche date et heure
                      } else {
                          console.log("Retour du cours incorrect, mauvais contenu dans l'appel");
                          document.getElementById("cours").innerHTML = " Retour du cours incorrect, mauvais contenu dans l'appel";
                      }
                  }
              }
          
              // ontimeout, fonction exécuté quand le délai accordé pour finalisé la requête est expirée
              ajax.ontimeout = function () {
                  console.log("Le service n'a pas répondu à temps : nouvel essai dans 5 sec");
                  document.getElementById("cours").innerHTML = "Le service n'a pas répondu à temps";
                  //Relancer l'appel 5 secondes plus tard, ici l'on peut mettre le un loader
                  setTimeout("getCours()", 5000);
              }
          
          
              // Préparation de la requête et envoi
              var url = "https://min-api.cryptocompare.com/data/price?fsym=BTC&tsyms=EUR";
              // var url = "https://min-api.cryptocompare.com/data/price?fsym=BTC&tsyms=EURfefezfefez";
              ajax.open("GET", url, true); // Méthode open() démarre une requête Ajax
              ajax.onerror = function () { // pas utiliser dans ce cas car il y a le onetimeout
                  console.log("erreur dans l'appel");
              }
              ajax.timeout = 1000; // Délai d'expiration à 1 seconde, si aucun timeout, ajouter le ajax oneerror
              ajax.send();// Méthode send() déclenche l'appel Ajax
          }
          // Démarrage de l'appel
          window.onload = function () {
              getCours();
              setInterval("getCours()", 30000); // se rééxécute toute les 30 secondes pour mettre à jours les info, pas obligatoire}`}
height={calcHeight(77)}
          width="100%"
        />
      </code>
      </pre>
      <div class="pageBreak"></div>
                    <h2>Quelques explications</h2>
                    <h3>Qu'est qu'un service web</h3>
                    <p>Un <strong>service web</strong> est un programme s'exécutant sur un serveur accessible depuis
                        Internet et répondant à des demandes, appelées <strong>requêtes</strong>.</p>
                    <p>Les <strong>requêtes</strong> sont des données qui respectent le protocole de communication et
                        qui sont envoyées au serveur.</p>
                    <p>Des <strong>protocoles de communication</strong> ont été mis en place afin de standardiser la
                        communication entre services faisant la même chose,
                        nous avons donc un protocole pour :</p>
                    <ul>
                        <li>l'envoi de mail (SMTP)</li>
                        <li>la réception de mail (IMAP)</li>
                        <li>les requêtes liées à des ressources web (HTTP)</li>
                        <li>les transferts de fichiers (FTP), etc.</li>
                    </ul>
                    <p><strong>HTTP</strong> signifie HyperText Transfer Protocol. C'est un protocole qui permet de
                        communiquer avec un site Internet.</p>
                    <p>Les codes HTTP :</p>
                    <ul>
                        <li>De <strong>100 à 199 </strong>: Code d'information (peu utilisé)</li>
                        <li>De <strong>200 à 299 </strong>: Code de succès.</li>
                        <li>De <strong>300 à 399 </strong>: Code de redirection (le contenu a bougé ou n'est pas
                            accessible directement</li>
                        <li>De <strong>400 à 499 </strong>: Code d'erreur liés à l'utilisation du service web</li>
                        <li>De <strong>500 à 599</strong>: Code d'erreur venant du service web (plantage du service,
                            manque de mémoire...)</li>
                    </ul>
                    <p>Les codes les plus fréquement rencontrés :</p>
                    <ul>
                        <li><strong>200 : </strong>indique que tout s'est bien passé</li>
                        <li><strong>201 : </strong>indique que tout s'est bien passé et qu'une nouvelle ressource a bien
                            été créée</li>
                        <li><strong>204 : </strong>indique que tout s'est bien passé mais qu'aucun résultat n'est
                            renvoyé</li>
                        <li><strong>400 : </strong>indique q'une requête est erronée</li>
                        <li><strong>401 : </strong>indique que l'utilisateur n'est pas authentifié, alors que c'est
                            nécessaire</li>
                        <li><strong>403 : </strong>indique que l'utilisateur n'a pas le droit d'accéder à cette
                            ressource</li>
                        <li><strong>404 : </strong>indique que la ressource demandée n'existe pas</li>
                        <li><strong>500 : </strong>indique que le serveur à subi une erreur interne</li>
                    </ul>
                    <p>Les méthodes HTTP :</p>
                    <ul>
                        <li><strong>GET : </strong>récupére des ressources</li>
                        <li><strong>POST : </strong>Créé ou modifie une ressource</li>
                        <li><strong>PUT : </strong>Modifie une ressource</li>
                        <li><strong>DELETE : </strong>Supprime une ressource</li>
                    </ul>
                    <p><strong>API</strong> signifie Application Programming Interface. Il s'agit d'une interface
                        mettant à disposition des points d'accès vers les ressources de l'application.</p>
                    <h3>Récupérer des données d'un service web</h3>
                    <p><strong>Ajax</strong> signifie en fait Asynchronous JavaScript And XML. Il s'agit d'un ensemble
                        d'objets et de fonctions mis à disposition par le langage JavaScript, afin d'exécuter des
                        requêtes HTTP de manière asynchrone.</p>
                    <p>Envoyer une première requête :</p>


                    <pre>
      <code>
      <AceEditor
        fontSize={16}
        showPrintMargin={false}
        showGutter= {true}
          mode="javascript"
          theme="monokai"
          value={`// Exemple de requête vers un service web
var request = new XMLHttpRequest(); 
request.open("GET", "http://url-service-web.com/api/users");
request.send();`}
          height={calcHeight(4)}
          width="100%"
        />
      </code>
      </pre>
      <ul>
                        <li><strong>Etape 1 : </strong>on créé un nouvel objet de type XMLHttpRequest qui correspond à
                            notre objet AJAX. C'est grâce à lui qu'on va créer et envoyer notre requête</li>
                        <li><strong>Etape 2 : </strong>on demande à ouvrir une connexion vers un service web. C'est ici
                            que l'on précise quelle méthode HTTP on souhaite, ainsi que l'URL du service web</li>
                        <li><strong>Etape 3 : </strong>on envoie finalement la requête au service web</li>
                    </ul>
                    <p>Il faut maintenant récupérer les données au <strong>format JSON</strong> (JavaScript Object
                        Notation). Il s'agit d'un <strong>format textuel</strong> se rapprochant en termes de syntaxe de
                        celui des objets dans le langage Javascript.</p>
                        <pre>
      <code>
      <AceEditor
        fontSize={16}
        showPrintMargin={false}
        showGutter= {true}
          mode="javascript"
          theme="monokai"
          value={`// Un objet Javascript
const obj = {
    name: "Mon contenu",
    id: 1234,
    message: "Voici mon contenu",
    author: {
        name: "John"
    },
    comments: [
        {
            id: 45,
            message: "Commentaire 1"
        },
        {
            id: 46,
            message: "Commentaire 2"
        }
    ]
};

// Un objet JSON
{
    "name": "Mon contenu",
    "id": 1234,
    "message": "Voici mon contenu",
    "author": {
        "name": "John"
    },
    "comments": [
        {
            "id": 45,
            "message": "Commentaire 1"
        },
        {
            id: 46,
            "message": "Commentaire 2"
        }
    ]
} `}
          height={calcHeight(39)}
          width="100%"
        />
      </code>
      </pre>
     
      <p>Récupérer le résultat de la requête avec <strong>onreadyStatechange</strong>, voici les
                        différents états possibles :</p>
                    <ul>
                        <li><strong>UNSENT</strong> : (code 0) l'objet est prêt mais la méthode open() n'a pas encore
                            été appelée</li>
                        <li><strong>OPENED</strong> : (code 1) open() a été appelé</li>
                        <li><strong>HEADERS_RECEIVED</strong> : (code 2) send() a été appelé, les headers et status sont
                            disponibles au sein de l'objet</li>
                        <li><strong>LOADING</strong> : (code 3) : réception en cours, les données reçues sont partielles
                        </li>
                        <li><strong>DONE</strong> : (code 4) : requête terminée</li>
                    </ul>

                    <ul>
                        <li><strong>readyState</strong> : qui contient l'état de la requête</li>
                        <li><strong>status</strong> : qui contient le code de statut de la requête (souvenez-vous, 2xx
                            quand ça s'est bien passé, 3xx pour les redirections, 4xx pour les erreurs...)</li>
                        <li><strong>responseText</strong> : qui contient la réponse du service web au format texte.
                            Ainsi, si le texte que l'on attend est au format JSON, il va falloir le transformer en objet
                            JavaScript avec la fonction <strong>JSON.parse(texteJSON)</strong></li>
                    </ul>


      </div>
    )
}
